import PagesTable from './PagesTable'
export { PagesTable }
export default PagesTable



// WEBPACK FOOTER //
// ./src/components/PagesTable/index.js